export default "__VITE_ASSET__pCR015tq__"